import apiService from './api';

const API_ROOT = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function normalizeApiError(error, fallbackMessage) {
  const message = error?.message ? String(error.message).trim() : '';
  return message || fallbackMessage;
}

function buildReportQuery(filters = {}) {
  const queryParams = new URLSearchParams();
  if (filters.from) queryParams.append('from', filters.from);
  if (filters.to) queryParams.append('to', filters.to);
  if (filters.site_id) queryParams.append('site_id', filters.site_id);
  if (filters.page) queryParams.append('page', filters.page);
  if (filters.limit) queryParams.append('limit', filters.limit);
  if (filters.q) queryParams.append('q', filters.q);
  if (filters.act_q) queryParams.append('act_q', filters.act_q);
  if (filters.company_id) queryParams.append('company_id', String(filters.company_id));
  if (filters.member_type) queryParams.append('member_type', filters.member_type);
  if (filters.sexe) queryParams.append('sexe', filters.sexe);
  if (filters.age_min != null && filters.age_min !== '') {
    queryParams.append('age_min', String(filters.age_min));
  }
  if (filters.age_max != null && filters.age_max !== '') {
    queryParams.append('age_max', String(filters.age_max));
  }
  if (filters.act_kind) queryParams.append('act_kind', filters.act_kind);
  return queryParams;
}

const clinicalReportsService = {
  async getOverview(filters = {}) {
    try {
      const queryString = buildReportQuery(filters).toString();
      const endpoint = `/clinical-reports/overview${queryString ? `?${queryString}` : ''}`;
      const response = await apiService.get(endpoint);
      return {
        success: Boolean(response.success),
        data: response.data,
        message: response.message || ''
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: normalizeApiError(error, 'Impossible de charger les statistiques.')
      };
    }
  },

  async getNursingActsSynthesis(filters = {}) {
    try {
      const queryString = buildReportQuery(filters).toString();
      const endpoint = `/clinical-reports/nursing-acts-synthesis${queryString ? `?${queryString}` : ''}`;
      const response = await apiService.get(endpoint);
      return {
        success: Boolean(response.success),
        data: response.data,
        message: response.message || ''
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: normalizeApiError(error, 'Impossible de charger le journal des actes.')
      };
    }
  },

  async getMorbidity(filters = {}) {
    try {
      const queryString = buildReportQuery(filters).toString();
      const endpoint = `/clinical-reports/morbidity${queryString ? `?${queryString}` : ''}`;
      const response = await apiService.get(endpoint);
      return {
        success: Boolean(response.success),
        data: response.data,
        message: response.message || ''
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: normalizeApiError(error, 'Impossible de charger le rapport de morbidité.')
      };
    }
  },

  async downloadNursingActsCsv(filters = {}) {
    const params = buildReportQuery(filters);
    const qs = params.toString();
    const token =
      typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('token') : null;
    const url = `${API_ROOT}/clinical-reports/nursing-acts-synthesis/export.csv${qs ? `?${qs}` : ''}`;
    const response = await fetch(url, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
    if (!response.ok) {
      let message = 'Export CSV impossible.';
      try {
        const data = await response.json();
        if (data.message) message = data.message;
      } catch (_) {
        /* ignore non-JSON error body */
      }
      throw new Error(message);
    }
    const blob = await response.blob();
    const anchor = document.createElement('a');
    const fromLabel = filters.from ? String(filters.from).slice(0, 10) : 'export';
    const toLabel = filters.to ? String(filters.to).slice(0, 10) : fromLabel;
    anchor.href = URL.createObjectURL(blob);
    anchor.download = `rapport_infirmerie_${fromLabel}_${toLabel}.csv`;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    URL.revokeObjectURL(anchor.href);
  }
};

export default clinicalReportsService;
